'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _ThreadListContainer = require('../containers/ThreadListContainer');

var _ThreadListContainer2 = _interopRequireDefault(_ThreadListContainer);

var _ThreadView = require('../components/ThreadView');

var _ThreadView2 = _interopRequireDefault(_ThreadView);

var _views = require('./constants/views');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CurrentView = function (_PureComponent) {
  _inherits(CurrentView, _PureComponent);

  function CurrentView() {
    _classCallCheck(this, CurrentView);

    return _possibleConstructorReturn(this, (CurrentView.__proto__ || Object.getPrototypeOf(CurrentView)).apply(this, arguments));
  }

  _createClass(CurrentView, [{
    key: 'renderView',
    value: function renderView() {
      var currentView = this.props.currentView;


      switch (currentView) {
        case _views.THREAD_VIEW:
          return _react2.default.createElement(_ThreadView2.default, {
            browserWindowHeight: this.props.browserWindowHeight,
            inline: this.props.inline,
            isOpen: this.props.isOpen,
            isUngatedForUTV: this.props.isUngatedForUTV,
            onUpdateOpened: this.props.onUpdateOpened,
            onUpdateSize: this.props.onUpdateSize
          });

        case _views.THREAD_LIST:
          return _react2.default.createElement(_ThreadListContainer2.default, {
            browserWindowHeight: this.props.browserWindowHeight,
            inline: this.props.inline,
            isOpen: this.props.isOpen,
            onUpdateOpened: this.props.onUpdateOpened,
            onUpdateSize: this.props.onUpdateSize
          });

        default:
          {
            return _react2.default.createElement('div', null);
          }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        {
          style: { height: '100%' },
          key: 'widget',
          ref: this.props.isOpen ? this.props.setWidgetRef : null
        },
        this.renderView()
      );
    }
  }]);

  return CurrentView;
}(_react.PureComponent);

CurrentView.displayName = 'CurrentView';

CurrentView.propTypes = {
  browserWindowHeight: _react.PropTypes.number.isRequired,
  currentView: _react.PropTypes.oneOf([_views.THREAD_VIEW, _views.THREAD_LIST]).isRequired,
  inline: _react.PropTypes.bool.isRequired,
  isOpen: _react.PropTypes.bool,
  isUngatedForUTV: _react.PropTypes.bool.isRequired,
  onUpdateOpened: _react.PropTypes.func.isRequired,
  onUpdateSize: _react.PropTypes.func.isRequired,
  setWidgetRef: _react.PropTypes.func.isRequired
};

exports.default = CurrentView;
module.exports = exports['default'];